<template>
	<vModal v-model="show" :title="getTitle" :width="getSize" v-bind="$attrs" @on-after-close="close">
		<template v-if="alert&&!component">
			<header slot="header" class="text-center" :class="['color-'+(alert||'error')]">
				<vIcon type="information-circle"></vIcon>
				<span v-html="getTitle"></span>
			</header>
			<div v-if="showDesc" class="margin-5 text-center" v-html="getDesc"></div>
			<compFormedit
				ref="formdata"
				class="margin-10"
				v-if="formdata&&formdata.length"
				:formdata="formdata"
				:value="formData"
			></compFormedit>
			<footer slot="footer" class="text-right">
				<vButton
					v-if="!single"
					:theme="alert||'error'"
					style="margin-right:20px;min-width:76px;"
					@click.native="handleConfirm"
				>{{confirmText||$t('global.common.update_OK')}}</vButton>
				<vButton style="min-width:76px;" @click.native="close">{{closeText||$t('global.modal.close')}}</vButton>
			</footer>
		</template>
		<template v-else>
			<slot></slot>
		</template>
		<vLoading v-if="innerLoading" loading fix @on-close="innerLoading=false" />
	</vModal>
</template>

<script>
import compFormedit from "./formedit";
export default {
	inheritAttrs: false,
	components: {
		compFormedit
	},
	props: {
		title: String,
		langKey: String,
		value: Boolean,
		loading: Boolean,
		closeText: String,
		confirmText: String,
		single: Boolean,//仅显示关闭按钮
		alert: String,
		component: {
			default: false
		},
		formdata: Array,
		params: Object,
		ajaxRequest: Function,
		width: {
			type: [String, Number],
			default: 360
		},
		desc: String,
		showDesc: {
			type: Boolean,
			default: true,
		},
		callback: Function,
		interceptRequest: Function
	},

	data() {
		return {
			innerLoading: false,
			show: this.value,
			formData: {},
		};
	},
	watch: {
		formdata() {
			this.getFormData();
		},
		value: {
			deep: true,
			immediate: true,
			handler(val) {
				this.show = val;
			}
		},
		show: {
			deep: true,
			immediate: true,
			handler(val) {
				this.$emit("input", val);
				if (!val) this.close();
			}
		},
		loading: {
			deep: true,
			immediate: true,
			handler(val) {
				this.innerLoading = val;
			}
		}
	},
	methods: {
		/**
		 * @description 初始化FormData默认值
		 */
		getFormData() {
			if (!Array.isArray(this.formdata)) return;
			const formData = {};
			this.formdata.forEach((item) => {
				const { key, default: value } = item;
				if (key && value !== undefined) {
					formData[key] = value;
				}
			})

			this.formData = formData;
		},
		async handleConfirm() {
			let params = this.params, interceptRequest = this.interceptRequest, ajaxRequest = this.ajaxRequest, callback = this.callback || (res => res&&this.$VMessage.success(res.message))
			if (this.formdata) {
				const ref = this.$refs.formdata;
				const bool = await ref.validate();
				if (!bool) return this.$VMessage.warning(this.$t('global.common.fill_required'));
				params = { ...params, ...ref.formData };
			}
			if (typeof interceptRequest === "function") params = interceptRequest.call(this, params, this);
            if(params == false){return};
            
			if (typeof ajaxRequest === 'function') {
				this.innerLoading = true;
				ajaxRequest(params).then(res => {
					this.$emit("on-confirm", params);
					if (typeof callback === "function") callback(res);
					this.close();
				}, err => {
					this.innerLoading = false;
					this.$VMessage.error(err.message);
				})
			} else {
				this.innerLoading = this.loading !== undefined ? true : false;
				this.$emit("on-confirm", params);
			}
		},
		close() {
			this.show = this.innerLoading = false;
			this.$emit('on-close');
		},
	},
	computed: {
		//获取标题
		getTitle() {
			return this.langKey ? this.$t(this.langKey, { defaultValue: this.title }) : this.title
		},
		getSize() {
			const width = this.width;
			switch (this.width) {
				case 'small': return 360;
				case 'middle': return 520;
				case 'normal': return 720;
				case 'large': return 1000;
				default: return width;
			}
		},
		getDesc() {
			return this.desc || `${this.$t('global.modal.confirm')} ${this.getTitle}?`;
		},

	}
};
</script>